import * as React from "react";

const Youtube: React.FC = () => {
    return <svg width="20px" height="14px" viewBox="0 0 20 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Global-Elements/Footer-WF" transform="translate(-1232.000000, -196.000000)" fill="currentColor">
            <g transform="translate(1027.000000, 155.000000)">
                <g transform="translate(0.000000, 29.000000)">
                    <g transform="translate(195.000000, 0.000000)">
                        <path d="M18.0001831,22.1133714 L18.0001831,14.777321 L23.7120715,18.4447518 L18.0001831,22.1133714 Z M30,14.9125463 C30,13.3035131 28.6621104,12 27.0105719,12 L12.9894281,12 C11.3378896,12 10,13.3035131 10,14.9125463 L10,22.7235201 C10,24.331959 11.3378896,25.6363636 12.9894281,25.6363636 L27.0105719,25.6363636 C28.6621104,25.6363636 30,24.331959 30,22.7235201 L30,14.9125463 Z"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Youtube);
